import { FLOOR_KEY } from 'common/consts/local-storage-key.const';
import { storageManager } from 'common/helpers/local-storege-manager.helper';
import { TRoomsParams } from 'common/types/floor-params.type';

export const getCalculatedRooms = () => {
  const roomsFromStorage = storageManager.getItem(FLOOR_KEY) as TRoomsParams[];
  if (roomsFromStorage !== null) {
    return roomsFromStorage;
  }
  return [];
};
